module.exports = __webpack_public_path__ + "static/media/33.70e727fa.mp3";